module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yscy",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "model_yscy_box"
  }, [_c('div', {
    staticClass: "yishengcaiyun"
  }, [_c('div', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "zhongdashi"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('label', [_vm._v("您的姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    class: _vm.user_name == '' ? '' : 'time_color',
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名（汉字或字母）",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "change": function($event) {
        return _vm.$Glb.validName(_vm.user_name)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item gender"
  }, [_c('label', [_vm._v("您的性别：")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('span', {
    class: _vm.radioModel ? 'radioY' : 'radioN',
    on: {
      "click": function($event) {
        _vm.radioModel = 1
      }
    }
  }, [_c('i')]), _vm._v(" "), _c('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.radioModel = 1
      }
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('span', {
    class: _vm.radioModel ? 'radioN' : 'radioY',
    on: {
      "click": function($event) {
        _vm.radioModel = 0
      }
    }
  }, [_c('i')]), _vm._v(" "), _c('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.radioModel = 0
      }
    }
  }, [_vm._v("女")])])]), _vm._v(" "), _c('div', {
    staticClass: "item calendar",
    on: {
      "click": function($event) {
        _vm.calendarShow = true
      }
    }
  }, [_c('label', [_vm._v("出生日期：")]), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    staticStyle: {
      "position": "relative",
      "overflow": "hidden"
    }
  }, [(!_vm.user_birthDay.date) ? _c('span', {
    staticClass: "time-unselect"
  }, [_vm._v("公历 1990-01-01 时辰不清楚")]) : _c('span', {
    staticClass: "time-select",
    attrs: {
      "id": "time-select"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_birthDay.selectType) + "\n                " + _vm._s(_vm.user_birthDay.selectType == '公历' ?
    ((_vm.user_birthDay.date.cYear) + "-" + (_vm.user_birthDay.date.cMonth) + "-" + (_vm.user_birthDay.date.cDay) + " " + (_vm.user_birthDay.date.hour)) :
    ((_vm.user_birthDay.date.lYear) + "年" + (_vm.user_birthDay.date.IMonthCn) + (_vm.user_birthDay.date.IDayCn) + " " + (_vm.user_birthDay.date.hour))) + "\n              ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calendarIcon),
      expression: "calendarIcon"
    }],
    staticClass: "icon-calendar",
    attrs: {
      "src": require("../_img/yscy_a_rili.png"),
      "alt": "日历图标",
      "id": "calendar-icon"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "lijicesuan"
  }, [_c('span', {
    directives: [{
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'ljcs',
        page: 'index'
      }),
      expression: "{ events: 'ljcs', page: 'index' }"
    }],
    staticClass: "ljcs_btn",
    on: {
      "click": function($event) {
        return _vm.GoTounlock()
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n            已有\n            "), _c('span', [_vm._v(_vm._s(_vm.apiData.num))]), _vm._v("位缘主测算\n          ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-six"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "marquee"
  }, [_c('ul', {
    ref: "marquee_b",
    staticClass: "str_move str_origin",
    style: ('top:' + _vm.marquee_b.count + 'px;' + (_vm.marquee_b.count == 0 ? '' : 'transition: all 50.0s linear;'))
  }, _vm._l((_vm.marquee_b.list), function(i, index) {
    return _c('li', {
      key: index
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(i.name) + "\n                  "), _c('span', [_vm._v(_vm._s(i.mobile))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(i.content))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "str_move str_origin",
    style: ('top:' +
      (_vm.marquee_b.count + _vm.marquee_b.spacing) +
      'px;' +
      (_vm.marquee_b.count == 0 ? '' : 'transition: all 50.0s linear;'))
  }, _vm._l((_vm.marquee_b.list), function(i, index) {
    return _c('li', {
      key: index
    }, [_c('h4', [_vm._v("\n                  " + _vm._s(i.name) + "\n                  "), _c('span', [_vm._v(_vm._s(i.mobile))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(i.content))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_bottom_btn),
      expression: "show_bottom_btn"
    }, {
      name: "burypoint",
      rawName: "v-burypoint",
      value: ({
        events: 'ljcs',
        page: 'index'
      }),
      expression: "{ events: 'ljcs', page: 'index' }"
    }],
    staticClass: "bottom-ljcs-btn",
    on: {
      "click": function($event) {
        return _vm.GoTounlock()
      }
    }
  })]), _vm._v(" "), _c('TheBubble', {
    attrs: {
      "bubbleApi": "/v1/Config/buyers"
    }
  }), _vm._v(" "), _c('calender2019', {
    attrs: {
      "show": _vm.calendarShow
    },
    on: {
      "confirm": _vm.setDate,
      "hide": function($event) {
        _vm.calendarShow = false
      }
    }
  }), _vm._v(" "), _c('PluErrHandle')], 1), _vm._v(" "), _c('hfooter', {
    attrs: {
      "modelProp": _vm.footerProp,
      "parentpage": "detail",
      "acceptname": "getDetailData",
      "bg": "#f2c67b"
    }
  }), _vm._v(" "), _c('floatmenu', {
    attrs: {
      "parentpage": "detail",
      "acceptName": "getDetailData"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-one"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('img', {
    attrs: {
      "src": require("../_img/yscy_a_mihuo.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-two"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('img', {
    attrs: {
      "src": require("../_img/yscy_a_1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../_img/yscy_a_informationi2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-three"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('img', {
    attrs: {
      "src": require("../_img/yscy_a_chart.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-four"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('img', {
    attrs: {
      "src": require("../_img/yscy_a_suggest_.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-five"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-content"
  }, [_c('img', {
    attrs: {
      "src": require("../_img/yscy_a_dsjs.png"),
      "alt": "大师介绍"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6280cc66","hasScoped":false}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/yscy/index/App.vue
// module id = vD3e
// module chunks = 2